import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { useHistory } from 'react-router-dom';
import KenColors from '../../../Helpers/Themes/kenColors';
import { useStyles } from './styles';
import routes from '../../../Utils/routes';
import Images from '../../../Assets/assetHelper';
import { truncateText } from '../../../Utils/helperFunctions';

const COECard: React.FC<{ cardData: any; path: string }> = ({ cardData, path }) => {
  const classes = useStyles();
  const navigate = useHistory();

  return (
    <Grid
      container
      direction="column"
      className={classes.coeCard}
      onClick={() => {
        navigate.push(`${path === 'resources' ? routes.deals : routes.coe}/${cardData.name}`, { state: { cardData: cardData, breadCrumbs: cardData.name } });
      }}
    >
      {/* Image */}
      <Grid item sx={{ mb: { xs: '9px', ultraHD: '12px' } }}>
        <img src={cardData.logo ? cardData.logo : Images.Images.DefaultOrganizationLogo} alt="Company Logo" className={classes.cardImage} />
      </Grid>

      {/* Card Header and Icon Button */}
      <Grid item className={classes.cardActionContainer}>
        <Typography className={classes.cardHeader}>{cardData.name}</Typography>
        <IconButton
          sx={{ p: '1px' }}
          onClick={(e) => {
            e.stopPropagation();
            navigate.push(`${path === 'resources' ? routes.deals : routes.coe}/${cardData.name}`, { state: { cardData: cardData, breadCrumbs: cardData.name } });
          }}
        >
          <ArrowForwardOutlinedIcon sx={{ height: { xs: '18px', ultraHD: '24px' }, color: KenColors.ClientBlack1 }} />
        </IconButton>
      </Grid>

      {/* Card Description */}
      <Grid item>
        <Typography className={classes.cardDescription}>{truncateText(cardData.description, 60)}</Typography>
      </Grid>
    </Grid>
  );
};

export default COECard;
